import script from "./MyConferences.vue?vue&type=script&setup=true&lang=js"
export * from "./MyConferences.vue?vue&type=script&setup=true&lang=js"

import "./MyConferences.vue?vue&type=style&index=0&id=293d78fd&lang=scss"

const __exports__ = script;

export default __exports__